module.exports = "https://r.nearpod.com/assets/media/image/open-ended-question-c0f1baeb6871cd08ae544c72bdaa2207.svg";